<div class="get-app-faq">
    <button type="button" nz-button nzType="default" class="{{className}}" (click)="showModal()">
      <ng-content></ng-content>
    </button>
    <nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" nzCentered [nzFooter]="null"
        nzClassName="get-app-faq-modal" nzWidth="600px">
        <ng-container *nzModalContent>
            <div class="get-app-faq-modal-header">
                <div class="get-app-faq-modal-header__icon">
                    <img src="assets/icons/InfoCircle/info_circle_outline_blue.svg" alt="info" />
                </div>
                <div class="get-app-faq-modal-header__description">
                    <h2>
                        {{'HOME.LOGIN_PAGE.GET_APP_MODAL_TITLE' | translate}}
                    </h2>

                </div>
            </div>

            <div class="stepper">
                <div class="stepper-block">
                    <div class="stepper__line" *ngIf="step === 1">
                    </div>
                    <div class="stepper__line active" *ngIf="step > 1">
                    </div>
                    <img
                    src="assets/icons/Step/step_active.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step === 1"
                    />
                    <img
                    src="assets/icons/Step/step_done.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step > 1"
                    />
                    <p *ngIf="step === 1" class="active">
                        {{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP1_TITLE' | translate}}
                    </p>
                    <a href="#" *ngIf="step === 1" class="upload-link" (click)="nextStepHandler()" target="_blank" rel="noopener noreferrer">
                        <img src="assets/icons/document_icon.svg" alt="document" />
                        {{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP1_LINK' | translate}}
                    </a>
                    <p *ngIf="step > 1">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP1_DONE' | translate}}</p>
                </div>
                <div class="stepper-block">
                    <div class="stepper__line" *ngIf="step < 3">
                    </div>
                    <div class="stepper__line active" *ngIf="step > 2">
                    </div>
                    <img
                    src="assets/icons/Step/step_disabled.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step < 3 && step !== 2"
                    />
                    <img
                    src="assets/icons/Step/step_active.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step === 2"
                    />
                    <img
                    src="assets/icons/Step/step_done.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step > 2"
                    />
                    <p *ngIf="step < 3 && step !== 2" class="disabled">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP2_TITLE' | translate}}</p>
                    <p *ngIf="step === 2" class="active">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP2_TITLE' | translate}}</p>
                    <a href="#" *ngIf="step === 2" (click)="nextStepHandler()" target="_blank" rel="noopener noreferrer" class="bg-link">
                        <img src="assets/icons/upload_icon.svg" alt="document" />
                        {{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP2_LINK' | translate}}
                    </a>
                    <p *ngIf="step > 2">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP2_DONE' | translate}}</p>
                </div>
                <div class="stepper-block">
                    <img
                    src="assets/icons/Step/step_disabled.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step < 4 && step !== 3"
                    />
                    <img
                    src="assets/icons/Step/step_active.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step === 3"
                    />
                    <img
                    src="assets/icons/Step/step_done.svg"
                    alt="document"
                    class="stepper__icon"
                    *ngIf="step === 4"
                    />
                    <p *ngIf="step < 4 && step !== 3" class="disabled">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP3_DISABLED' | translate}}</p>
                    <p *ngIf="step === 3" class="active">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP3_TITLE' | translate}}</p>
                    <p *ngIf="step === 4">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP3_DONE' | translate}}</p>
                    <a href="#" *ngIf="step === 3" (click)="nextStepHandler()" target="_blank" rel="noopener noreferrer" class="bg-link">{{'HOME.LOGIN_PAGE.GET_APP_MODAL_STEP3_LINK' | translate}}</a>
                </div>
                <a href="#" *ngIf="step < 4" class="upload-link" target="_blank" rel="noopener noreferrer">
                    <img src="assets/icons/document_icon.svg" alt="document" />
                    {{'HOME.LOGIN_PAGE.GET_APP_MODAL_FAQ_LINK' | translate}}
                </a>
                <button *ngIf="step === 4" class="login-form__login-btn" nz-button nzType="primary" nzSize="large" [nzLoading]="isLoading"
                    [translate]="'HOME.LOGIN_PAGE.MODAL_BTN_LOGIN'" type="submit">
                    Войти в BCC Business
                </button>
            </div>
        </ng-container>
    </nz-modal>
</div>
